import React, { createContext, useContext, useState } from "react";

const EpkWizardContext = createContext({ isOpen: false, openWizard: () => {}, closeWizard: () => {} });

export function EpkWizardProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <EpkWizardContext.Provider value={{ isOpen, openWizard: () => setIsOpen(true), closeWizard: () => setIsOpen(false) }}>
      {children}
    </EpkWizardContext.Provider>
  );
}

export const useEpkWizard = () => useContext(EpkWizardContext);
